export enum StateEnum {
  AL = 'AL',
  AK = 'AK',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  DC = 'DC',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
  NO_STATE_SELECTED = ''
}

export enum StateNameUppercaseForReports {
  COLORADO = 'COLORADO',
  PENNSYLVANIA = 'PENNSYLVANIA',
  NEW_JERSEY = 'NEW JERSEY',
  INDIANA = 'INDIANA',
  MASSACHUSETTS = 'MASSACHUSETTS',
  TENNESSEE = 'TENNESSEE'
}

type StateOption = {
  value: StateEnum
  label: string
}

export const STATE_OPTIONS: StateOption[] = [
  { value: StateEnum.AL, label: 'Alabama' },
  { value: StateEnum.AK, label: 'Alaska' },
  { value: StateEnum.AZ, label: 'Arizona' },
  { value: StateEnum.AR, label: 'Arkansas' },
  { value: StateEnum.CA, label: 'California' },
  { value: StateEnum.CO, label: 'Colorado' },
  { value: StateEnum.CT, label: 'Connecticut' },
  { value: StateEnum.DE, label: 'Delaware' },
  { value: StateEnum.DC, label: 'District Of Columbia' },
  { value: StateEnum.FL, label: 'Florida' },
  { value: StateEnum.GA, label: 'Georgia' },
  { value: StateEnum.HI, label: 'Hawaii' },
  { value: StateEnum.ID, label: 'Idaho' },
  { value: StateEnum.IL, label: 'Illinois' },
  { value: StateEnum.IN, label: 'Indiana' },
  { value: StateEnum.IA, label: 'Iowa' },
  { value: StateEnum.KS, label: 'Kansas' },
  { value: StateEnum.KY, label: 'Kentucky' },
  { value: StateEnum.LA, label: 'Louisiana' },
  { value: StateEnum.ME, label: 'Maine' },
  { value: StateEnum.MD, label: 'Maryland' },
  { value: StateEnum.MA, label: 'Massachusetts' },
  { value: StateEnum.MI, label: 'Michigan' },
  { value: StateEnum.MN, label: 'Minnesota' },
  { value: StateEnum.MS, label: 'Mississippi' },
  { value: StateEnum.MO, label: 'Missouri' },
  { value: StateEnum.MT, label: 'Montana' },
  { value: StateEnum.NE, label: 'Nebraska' },
  { value: StateEnum.NV, label: 'Nevada' },
  { value: StateEnum.NH, label: 'New Hampshire' },
  { value: StateEnum.NJ, label: 'New Jersey' },
  { value: StateEnum.NM, label: 'New Mexico' },
  { value: StateEnum.NY, label: 'New York' },
  { value: StateEnum.NC, label: 'North Carolina' },
  { value: StateEnum.ND, label: 'North Dakota' },
  { value: StateEnum.OH, label: 'Ohio' },
  { value: StateEnum.OK, label: 'Oklahoma' },
  { value: StateEnum.OR, label: 'Oregon' },
  { value: StateEnum.PA, label: 'Pennsylvania' },
  { value: StateEnum.RI, label: 'Rhode Island' },
  { value: StateEnum.SC, label: 'South Carolina' },
  { value: StateEnum.SD, label: 'South Dakota' },
  { value: StateEnum.TN, label: 'Tennessee' },
  { value: StateEnum.TX, label: 'Texas' },
  { value: StateEnum.UT, label: 'Utah' },
  { value: StateEnum.VT, label: 'Vermont' },
  { value: StateEnum.VA, label: 'Virginia' },
  { value: StateEnum.WA, label: 'Washington' },
  { value: StateEnum.WV, label: 'West Virginia' },
  { value: StateEnum.WI, label: 'Wisconsin' },
  { value: StateEnum.WY, label: 'Wyoming' },
  { value: StateEnum.NO_STATE_SELECTED, label: 'No State Selected' }
]

export const STATE_OPTIONS_FOR_REPORTS: { value: string; label: string }[] = [
  { value: StateNameUppercaseForReports.COLORADO, label: 'Colorado' },
  { value: StateNameUppercaseForReports.PENNSYLVANIA, label: 'Pennsylvania' },
  { value: StateNameUppercaseForReports.NEW_JERSEY, label: 'New Jersey' },
  { value: StateNameUppercaseForReports.INDIANA, label: 'Indiana' },
  { value: StateNameUppercaseForReports.MASSACHUSETTS, label: 'Massachusetts' },
  { value: StateNameUppercaseForReports.TENNESSEE, label: 'Tennessee' }
]

// State to timezone mapping (mirrors backend constants/state.py)
export const STATE_TIMEZONES: Record<string, string> = {
  AL: 'America/Chicago',
  AK: 'America/Anchorage',
  AZ: 'America/Phoenix',
  AR: 'America/Chicago',
  CA: 'America/Los_Angeles',
  CO: 'America/Denver',
  CT: 'America/New_York',
  DE: 'America/New_York',
  FL: 'America/New_York',
  GA: 'America/New_York',
  HI: 'Pacific/Honolulu',
  ID: 'America/Denver',
  IL: 'America/Chicago',
  IN: 'America/New_York',
  IA: 'America/Chicago',
  KS: 'America/Chicago',
  KY: 'America/New_York',
  LA: 'America/Chicago',
  ME: 'America/New_York',
  MD: 'America/New_York',
  MA: 'America/New_York',
  MI: 'America/New_York',
  MN: 'America/Chicago',
  MS: 'America/Chicago',
  MO: 'America/Chicago',
  MT: 'America/Denver',
  NE: 'America/Chicago',
  NV: 'America/Los_Angeles',
  NH: 'America/New_York',
  NJ: 'America/New_York',
  NM: 'America/Denver',
  NY: 'America/New_York',
  NC: 'America/New_York',
  ND: 'America/Chicago',
  OH: 'America/New_York',
  OK: 'America/Chicago',
  OR: 'America/Los_Angeles',
  PA: 'America/New_York',
  RI: 'America/New_York',
  SC: 'America/New_York',
  SD: 'America/Chicago',
  TN: 'America/Chicago',
  TX: 'America/Chicago',
  UT: 'America/Denver',
  VT: 'America/New_York',
  VA: 'America/New_York',
  WA: 'America/Los_Angeles',
  WV: 'America/New_York',
  WI: 'America/Chicago',
  WY: 'America/Denver',
  DC: 'America/New_York'
}

export const getTimezoneForState = (stateAbbreviation: string): string => {
  const timezone = STATE_TIMEZONES[stateAbbreviation]
  if (!timezone) {
    throw new Error(`Invalid or missing state abbreviation: "${stateAbbreviation}"`)
  }
  return timezone
}

export function getStateLabel(stateCode: string): string {
  return STATE_OPTIONS.find((option) => option.value === stateCode)?.label ?? stateCode
}
